import { render, staticRenderFns } from "./CsoCoreIndicators.vue?vue&type=template&id=e5628790&scoped=true"
import script from "./CsoCoreIndicators.vue?vue&type=script&lang=js"
export * from "./CsoCoreIndicators.vue?vue&type=script&lang=js"
import style0 from "./CsoCoreIndicators.vue?vue&type=style&index=0&id=e5628790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5628790",
  null
  
)

export default component.exports